<template>
  <div class="container">
    <!-- header导航 -->
    <Iheaders></Iheaders>
    <keep-alive>
      <!-- <transition name="fade" mode="out-in" appear> -->
      <router-view style="position: relative; top: 64px"> </router-view>
      <!-- </transition> -->
    </keep-alive>
    <!-- 底部 -->
    <Ifooters></Ifooters>
  </div>
</template>
<script>
import iheader from "@/components/pc/header.vue";
import ifooter from "@/components/pc/footer.vue";
export default {
  components: {
    Iheaders: iheader,
    Ifooters: ifooter,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  min-width: 1420px;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/Web.vue